// "Найден N товар(/а/ов)" with the verb agreeing with the count:
//   1  → «Найден 1 товар»      (11 → «Найдено 11 товаров»)
//   2–4 → «Найдено 2 товара»   (12–14 → «Найдено 12 товаров»)
//   else → «Найдено N товаров»
export const getFoundLabel = (count: number): string => {
	const mod10 = count % 10
	const mod100 = count % 100

	const isOne = mod10 === 1 && mod100 !== 11
	const isFew = mod10 >= 2 && mod10 <= 4 && !(mod100 >= 12 && mod100 <= 14)

	const verb = isOne ? 'Найден' : 'Найдено'
	const noun = isOne ? 'товар' : isFew ? 'товара' : 'товаров'

	return `${verb} ${count} ${noun}`
}
